webpackJsonp([246979130638502],{

/***/ 373:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/blog/2009-07-23-our-phone-system.md absPath of file >>> MarkdownRemark","html":"<p style=\"text-align: center;\">\n  <img class=\"aligncenter\" src=\"\"http://floatsolutions.net/docs/My-Phone-%28Medium%29.jpg\" alt=\"\" />\n</p>\n<p>Cheap telecom in the internet age  &#x3C;img src=\"'<a href=\"http://floatsolutions.com/wp-includes/images/smilies/icon_wink.gif\">http://floatsolutions.com/wp-includes/images/smilies/icon_wink.gif</a>' alt=';)' class='wp-smiley' /></p>","frontmatter":{"date":"July 23, 2009","title":"Our Phone System","description":null,"tags":["Desktop Customization"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/blog/2009-07-23-our-phone-system.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-2009-07-our-phone-system-fc3a018b4ea6c29b10e8.js